import { Action } from 'redux'
import { IDriver } from './driver'
import { IMotorCarrier } from './entity'

export interface IStoreState {
  fetching: boolean
  error?: string
}

export interface IAction extends Action<string> {
  error?: string
  payload: any
}

export interface IDetailsModalPayload {
  id?: string
}

export interface IShareLoads {
  shipmentId?: string
  message?: string
}

export interface IModalsState {
  error?: string
  actionInProgress?: boolean
  isDriverOptInModalOpen?: boolean
  drivers?: IDriver[]
  shareLoads?: IShareLoads
}

export interface IDispatcher {
  id: string
  shipperId?: string
  carrierId?: string
  firstName?: string
  lastName?: string
  fullName?: string
  motorCarriers?: IMotorCarrier[]
}

export enum SORT_ORDER {
  ASC = 'asc',
  DESC = 'desc',
}
